export function getEnvironment() {
  const host = (typeof window !== "undefined" && window.location && window.location.hostname)
    ? window.location.hostname.toLowerCase()
    : "";

  if (host.includes("development")) return "development";
  if (host.includes("staging")) return "staging";
  if (host.includes("stable")) return "stable";
  return "production";
}
